import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "../../components/common.js";

Vue.component("common", Common);

new Vue({
  el: "#uz-daeho-equipment",
  data: function() {
    return {
        viewModel: {
            list: [],
        },
        loadedImagesCount: 0,
        isotopeInitialized: false
    };
  },
  mounted: function() {
    let vm = this;
    try {
      vm.fnGetList();
    } catch (e) {
      console.log(e);
    }
  },
  updated: function() {
    // DOM이 업데이트될 때마다 체크
    if (!this.isotopeInitialized && this.viewModel.list.length > 0) {
      this.$nextTick(() => {
        this.initIsotope();
      });
    }
  },
  methods: {
    fnGetList: function(){
      let vm = this;
      Axios.post("/taejung/board/list", {bbsId: "DH_EQUIPMENT"})
          .then(function(response) {
            let rs = response.data;
            vm.viewModel.list = rs.list;
            for (var i = 0; i < vm.viewModel.list.length; i++) {
              vm.viewModel.list[i].create_date = Common.fnConvertDateStr(vm.viewModel.list[i].create_date, "-");
            }
          })
          .catch(function(ex) {
            console.log(ex);
          });
    },
    
    onImageLoad: function() {
      this.loadedImagesCount++;
      // 모든 이미지가 로드되면 레이아웃 재계산
      if (this.loadedImagesCount === this.viewModel.list.length) {
        this.$nextTick(() => {
          this.recalculateLayout();
        });
      }
    },
    
    initIsotope: function() {
      let vm = this;
      
      if (window.$ && window.Isotope) {
        // 약간의 지연 후 초기화
        setTimeout(() => {
          const $container = $('.iso-container2');
          
          $container.isotope({
            itemSelector: '.isotope-item',
            layoutMode: 'masonry',
            percentPosition: true,
            masonry: {
              columnWidth: '.isotope-item'
            }
          });
          
          vm.isotopeInitialized = true;
          
          // lightgallery 초기화
          if (window.lightGallery) {
            lightGallery(document.getElementById('lightgallery2'), {
              selector: '.isotope-item'
            });
          }
        }, 200);
      }
    },
    
    recalculateLayout: function() {
      if (window.$ && $('.iso-container2').data('isotope')) {
        $('.iso-container2').isotope('layout');
      }
    }
  }
});


// WEBPACK FOOTER //
// ./src/uz/daehounc/daehounc-equipment-controller.js